import React, { createContext, useContext } from 'react'
import type { ThemeType, ColorScheme } from '@/types'
import { COLOR_SCHEMES } from './themeConfig'

interface ThemeContextValue {
  theme: ThemeType
  colorScheme: ColorScheme
  colors: (typeof COLOR_SCHEMES)[ColorScheme]
  animationsEnabled: boolean
}

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined)

interface ThemeProviderProps {
  theme: ThemeType
  colorScheme: ColorScheme
  animationsEnabled?: boolean
  children: React.ReactNode
}

export function ThemeProvider({
  theme,
  colorScheme,
  animationsEnabled = true,
  children,
}: ThemeProviderProps) {
  const colors = COLOR_SCHEMES[colorScheme]

  return (
    <ThemeContext.Provider value={{ theme, colorScheme, colors, animationsEnabled }}>
      <div
        className={`theme-${theme} color-${colorScheme} ${!animationsEnabled ? 'reduce-motion' : ''}`}
        style={
          {
            '--color-primary': colors.primary,
            '--color-primary-light': colors.primaryLight,
            '--color-primary-dark': colors.primaryDark,
          } as React.CSSProperties
        }
      >
        {children}
      </div>
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider')
  }
  return context
}
